module.exports = __webpack_public_path__ + "static/media/js5.91cb9d9c.jpg";